import React from 'react';
import { AvatarPanel } from '../AvatarPanel/avatarPanel';
import { TransactionType } from './transactionElement';

export const TransactionAvatar = ({
	subject,
	type,
	handleInfo = () => {},
}: {
	subject: { address: string; icon: string };
	type: TransactionType;
	handleInfo?: () => void;
}) => {
	return (
		<AvatarPanel
			maxW="36px"
			maxH="36px"
			name={'T X'}
			ico={subject.icon}
			handleInfo={handleInfo}
		/>
	);
};
